import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import { css } from "styled-components";

savedOrderListFilterStyles.heading = {
    variant: "h5",
    css: css`
        margin: 0;
        text-transform: uppercase;
    `,
};

savedOrderListFilterStyles.clearFiltersButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        margin-right: 10px;
        margin-bottom: 25px;
        border: 1px solid rgb(1, 11, 19) !important;
    `,
};

savedOrderListFilterStyles.appliedFilterTag = {
    css: css`
        button {
            border: none !important;
            background: none !important;
            display: flex;
        }
    `,
};

savedOrderListTableStyles.orderDateCell = {
    css: css`
        span {
            color: #006bc0 !important;
        }
    `,
};

savedOrderListFilterStyles.toDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        formInputWrapper: css`
        @media (min-width: 0px) and (max-width: 348px) {
            div[class^="react-datetime-picker"]{
                padding:0px 1px !important;
                font-size: 14px !important;
                input {
                    padding: 1px !important;
                }
            }
            button {
                span[class^="IconWrapper"] {
                    padding: 3px !important;
                    svg {
                        height:20px !important;
                        width:20px !important;
                    }
                }   
            }
    `,
    },
};

savedOrderListFilterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
        formInputWrapper: css`
        @media (min-width: 0px) and (max-width: 348px) {
            div[class^="react-datetime-picker"]{
                padding:0px 1px !important;
                font-size: 14px !important;
                input {
                    padding: 1px !important;
                }
            }
            button {
                span[class^="IconWrapper"] {
                    padding: 3px !important;
                    svg {
                        height:20px !important;
                        width:20px !important;
                    }
                }   
            }
    `,
    },
};
